import BadgeWithIcon from "../../../../../../../components/badgeWithIcon/badgeWithIcon";
import { STATUS_COLOR_MAP } from "../playGroundConstants";
import { ExecutionStatus } from "../playGroundTypes";

interface StatusBadgeProps {
  status: ExecutionStatus;
}

const StatusBadge = ({ status }: StatusBadgeProps) => {
  const colorConfig = STATUS_COLOR_MAP[status];

  return (
    <BadgeWithIcon
      id={`status-badge-${status}`}
      text={status}
      bgColor={colorConfig.bgColor}
      textColor={colorConfig.textColor}
    />
  );
};

export default StatusBadge;
